import { useCallback, useEffect, useState } from 'react'
import { SearchResponse } from '@user/store/search/typings'
import { getSearchResults } from '../utils/getSearchResults'

export type statusType = 'idle' | 'pending' | 'success' | 'fail'

export function useGetSearchResults(search: string) {
  const [searchStatus, setSearchStatus] = useState<statusType>('idle')
  const [searchData, setSearchData] = useState<SearchResponse | undefined>(
    undefined,
  )

  const normalizePhoneNumber = useCallback((input: string) => {
    // Remove spaces, dashes, parentheses
    return input.replace(/[()\-\s]/g, '')
  }, [])

  useEffect(() => {
    let mounted = true
    const execute = async () => {
      setSearchStatus('pending')

      let query = search
      if (/^[\d\-\s()]+$/.test(search)) {
        query = normalizePhoneNumber(search)
      }

      const response = await getSearchResults(query)
      if (!mounted) return
      setSearchStatus(response.status as statusType)
      setSearchData(response.data as SearchResponse)
    }
    if (search?.trim().length > 2) {
      execute()
    } else {
      setSearchStatus('idle')
      setSearchData(undefined)
    }
    return () => {
      mounted = false
    }
  }, [normalizePhoneNumber, search])
  return { searchStatus, searchData }
}
